(function(){
  if (window.__v4CartInit) return;
  window.__v4CartInit = true;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var Q = String.fromCharCode(34), A = String.fromCharCode(39);
  var el = null, lastFocus = null, recCache = {}, open = false;

  function V(){ return window.DanellaV4 || {}; }
  function esc(s){ return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(Q).join('&quot;').split(A).join('&#39;'); }
  function money(c){ var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function sized(u, w){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function isRoutine(i){ return /bundle|gift set/i.test(i.product_type || i.type || '') || i.vendor === 'Danella Beauty'; }
  function isGift(i){ return !!(i.properties && (i.properties._gift || i.properties.Gift)); }
  function ssOn(){ var v = V(); return !!(v.ssOn && v.ssOn()); }
  function pathOf(h){ var s = String(h || '').split('#')[0].split('?')[0]; var i = s.indexOf('://'); if (i > -1) { s = s.slice(i + 3); var j = s.indexOf('/'); s = j > -1 ? s.slice(j) : '/'; } while (s.length > 1 && s.charAt(s.length - 1) === '/') s = s.slice(0, -1); return s; }
  function isCart(h){ var p = pathOf(h); return p === '/cart' || p.slice(-5) === '/cart'; }
  function cents(p){ if (typeof p === 'string' && p.indexOf('.') > -1) return Math.round(parseFloat(p) * 100); return Number(p) || 0; }

  function build(){
    if (el) return el;
    el = document.createElement('div');
    el.id = 'V4Cart';
    el.className = 'v4c';
    el.hidden = true;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Your bag');
    el.innerHTML = `<div class='v4c__backdrop' data-v4c-close></div><aside class='v4c__panel' tabindex='-1'><header class='v4c__head'><h2 class='v4c__title'>Your bag <span data-v4c-count></span></h2><button type='button' class='v4c__x' data-v4c-close aria-label='Close bag'>&times;</button></header><div class='v4c__body' data-v4c-body></div></aside>`;
    document.body.appendChild(el);
    el.addEventListener('click', onClick);
    return el;
  }

  function eligibleSubtotal(cart){
    var s = 0;
    cart.items.forEach(function(i){ if (!isRoutine(i) && !isGift(i)) s += (i.original_line_price != null ? i.original_line_price : i.line_price); });
    return s;
  }

  function progressHtml(cart){
    var v = V(), h = '';
    if (ssOn()) {
      var tiers = v.spendSave.tiers;
      var top = tiers[tiers.length - 1].min * 100;
      var elig = eligibleSubtotal(cart);
      var cur = v.tierFor(elig), nxt = v.nextTier(elig), msg;
      if (cur && nxt) msg = `You&rsquo;re saving <b>${cur.pct}%</b>. ${money(nxt.min * 100 - elig)} more for ${nxt.pct}% off`;
      else if (cur) msg = `You&rsquo;re saving <b>${cur.pct}%</b>. That&rsquo;s our best discount!`;
      else msg = `Add <b>${money(nxt.min * 100 - elig)}</b> more to save ${nxt.pct}%`;
      var pct = Math.min(100, Math.round(elig / top * 100));
      h += `<div class='v4c__prog'><p class='v4c__msg'>${msg}</p><div class='v4c__bar'><i style='width:${pct}%'></i></div><div class='v4c__ticks'>`;
      tiers.forEach(function(t){
        var on = elig >= t.min * 100;
        h += `<span class='${on ? 'on' : ''}' style='left:${Math.round(t.min * 100 / top * 100)}%'>${t.pct}%<small>$${t.min}</small></span>`;
      });
      h += `</div><p class='v4c__fine2'>Single products only. Routines and sets are already discounted.</p></div>`;
    }
    var fs = (v.freeShip || 65) * 100, left = fs - cart.total_price;
    h += `<p class='v4c__ship'>${left > 0 ? `You&rsquo;re <b>${money(left)}</b> away from <b>free shipping</b>` : `<b>Free shipping</b> unlocked`}</p>`;
    return h;
  }

  function itemHtml(it, idx){
    var line = idx + 1, gift = isGift(it);
    var disc = it.final_line_price < it.original_line_price;
    var price;
    if (gift) price = `<b>FREE</b>`;
    else if (disc) price = `<s>${money(it.original_line_price)}</s><em>&minus;${money(it.original_line_price - it.final_line_price)}</em><b>${money(it.final_line_price)}</b>`;
    else price = `<b>${money(it.final_line_price)}</b>`;
    var vt = it.variant_title && !/default title/i.test(it.variant_title) ? `<p class='v4c__var'>${esc(it.variant_title)}</p>` : '';
    var qty = gift ? `<span class='v4c__tag'>Free gift</span>` :
      `<div class='v4c__qty'><button type='button' data-v4c-qty='${line}:${it.quantity - 1}' aria-label='Decrease quantity'>&minus;</button><span>${it.quantity}</span><button type='button' data-v4c-qty='${line}:${it.quantity + 1}' aria-label='Increase quantity'>+</button></div><button type='button' class='v4c__rm' data-v4c-qty='${line}:0'>Remove</button>`;
    return `<div class='v4c__item'><a class='v4c__img' href='${esc(it.url)}'>${it.image ? `<img src='${esc(sized(it.image, 200))}' alt='' width='80' height='80' loading='lazy'>` : ''}</a><div class='v4c__info'><p class='v4c__vendor'>${esc(it.vendor)}</p><a class='v4c__name' href='${esc(it.url)}'>${esc(it.product_title)}</a>${vt}<div class='v4c__row'>${qty}</div></div><div class='v4c__price'>${price}</div></div>`;
  }

  function footHtml(cart){
    var v = V();
    var disc = cart.total_discount || 0;
    var chip = disc > 0 ? `<span class='v4c__chip'>${money(disc)} saved</span>` : '';
    var strike = disc > 0 ? `<s>${money(cart.original_total_price)}</s>` : '';
    var fs = (v.freeShip || 65) * 100;
    var shipTxt = cart.total_price >= fs ? 'Shipping: <b>free</b>' : `Shipping: $5.95, free over ${money(fs)} after savings`;
    return `<div class='v4c__foot'><div class='v4c__sub'><span>Subtotal ${chip}</span><span>${strike} <b>${money(cart.total_price)}</b></span></div><p class='v4c__fine'>${shipTxt}. Taxes calculated at checkout.</p><a class='v4c__checkout' href='/checkout'>Checkout</a><a class='v4c__view' href='${esc(v.cartUrl || '/cart')}'>View full bag</a><p class='v4c__pay'>Visa &middot; Mastercard &middot; Amex &middot; Apple Pay &middot; Google Pay &middot; Shop Pay &middot; PayPal</p></div>`;
  }

  function recsHtml(list){
    if (!list || !list.length) return '';
    var h = `<div class='v4c__recs'><p class='v4c__recs-title'>Complete your routine</p>`;
    list.forEach(function(p){
      var vr = p.variants && p.variants[0];
      if (!vr || vr.available === false) return;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img && img.src) img = img.src;
      var full = cents(vr.price), sale = Math.round(full * 0.8);
      h += `<div class='v4c__rec'><a class='v4c__rimg' href='${esc(p.url)}'>${img ? `<img src='${esc(sized(img, 160))}' alt='' width='56' height='56' loading='lazy'>` : ''}</a><div class='v4c__rinfo'><p class='v4c__vendor'>${esc(p.vendor)}</p><a href='${esc(p.url)}' class='v4c__rname'>${esc(p.title)}</a><span class='v4c__rprice'><s>${money(full)}</s> <b>${money(sale)}</b></span></div><button type='button' class='v4c__radd' data-v4c-add='${vr.id}' aria-label='Add ${esc(p.title)}'>+</button></div>`;
    });
    return h + '</div>';
  }

  function render(cart){
    build();
    var body = el.querySelector('[data-v4c-body]');
    var cnt = el.querySelector('[data-v4c-count]');
    if (cnt) cnt.textContent = '(' + cart.item_count + ')';
    document.querySelectorAll('[data-cart-count]').forEach(function(c){ c.textContent = cart.item_count; c.classList.toggle('is-empty', cart.item_count === 0); });
    if (!cart.items.length) {
      body.innerHTML = `<div class='v4c__empty'><p>Your bag is empty.</p><a class='v4c__checkout' href='/collections/all'>Start shopping</a></div>`;
      return;
    }
    var h = progressHtml(cart) + `<div class='v4c__items'>`;
    cart.items.forEach(function(it, i){ h += itemHtml(it, i); });
    h += `</div><div data-v4c-recs></div>` + footHtml(cart);
    body.innerHTML = h;
    loadRecs(cart);
  }

  function fetchRecs(pid, intent){
    return fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent, { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(j){ return j.products || []; })
      .catch(function(){ return []; });
  }

  function loadRecs(cart){
    var first = cart.items.filter(function(i){ return !isGift(i); })[0];
    if (!first) return;
    var pid = first.product_id;
    function paint(list){
      var inCart = {};
      cart.items.forEach(function(i){ inCart[i.product_id] = 1; });
      var f = (list || []).filter(function(p){ return !inCart[p.id] && !isRoutine(p); }).slice(0, 3);
      var slot = el && el.querySelector('[data-v4c-recs]');
      if (slot) slot.innerHTML = recsHtml(f);
    }
    if (recCache[pid]) { paint(recCache[pid]); return; }
    fetchRecs(pid, 'complementary')
      .then(function(l){ return l.length ? l : fetchRecs(pid, 'related'); })
      .then(function(l){ recCache[pid] = l; paint(l); });
  }

  function getCart(){ return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }); }

  function onKey(e){
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = el.querySelectorAll('button:not([disabled]),a[href]');
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  function openDrawer(cart){
    build();
    render(cart);
    if (!open) {
      lastFocus = document.activeElement;
      el.hidden = false;
      void el.offsetWidth;
      el.classList.add('is-open');
      document.documentElement.classList.add('v4c-lock');
      document.addEventListener('keydown', onKey, true);
      open = true;
      var p = el.querySelector('.v4c__panel');
      if (p) p.focus();
    }
  }

  function close(){
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('v4c-lock');
    document.removeEventListener('keydown', onKey, true);
    open = false;
    setTimeout(function(){ if (!open) el.hidden = true; }, 240);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function change(line, qty){
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function(r){ return r.json(); }).then(render);
  }

  function onClick(e){
    var t = e.target;
    if (t.closest('[data-v4c-close]')) { close(); return; }
    var q = t.closest('[data-v4c-qty]');
    if (q) { var p = q.getAttribute('data-v4c-qty').split(':'); q.disabled = true; change(Number(p[0]), Number(p[1])); return; }
    var a = t.closest('[data-v4c-add]');
    if (a) {
      a.disabled = true;
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(a.getAttribute('data-v4c-add')), quantity: 1 }) })
        .then(function(){ return getCart(); }).then(render).catch(function(){ a.disabled = false; });
    }
  }


  /* Biodance mask add-on: a tick box on every healthy and skin-concern routine page, so the mask goes into the bag with the routine. */
  var MASK_HANDLE = 'biodance-bio-collagen-real-deep-face-sheet-mask';
  var MASK_ROUTINES = ',acne-blemish-routine,pores-texture-routine,dark-spots-even-tone-routine,dullness-glow-routine,dryness-hydration-routine,redness-barrier-routine,firming-fine-lines-routine,';
  function maskPage(){
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    if (!m) return false;
    var h = m[1];
    return /^healthy-.+-routine$/.test(h) || MASK_ROUTINES.indexOf(',' + h + ',') > -1;
  }
  function mountMask(){
    if (!maskPage() || document.querySelector('[data-db-mask-card]')) return;
    var actions = document.querySelector('form[data-product-form] .product-form__actions');
    if (!actions) return;
    fetch(ROOT + 'products/' + MASK_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !p.variants || !p.variants.length || document.querySelector('[data-db-mask-card]')) return;
        var vr = null;
        p.variants.forEach(function(x){ if (!vr && x.available) vr = x; });
        if (!vr) return;
        var full = Number(vr.price) || 0, sale = ssOn() ? full : Math.round(full * 0.8);
        if (!document.getElementById('db-mask-css')) {
          var st = document.createElement('style');
          st.id = 'db-mask-css';
          st.textContent = '.db-mask{display:flex;align-items:center;gap:1rem;margin:0 0 1.4rem;padding:1.1rem 1.2rem;background:#fff;border:1.5px solid #e3dad3;border-radius:1.2rem;cursor:pointer;transition:border-color .15s,background .15s}.db-mask:hover{border-color:#c79aa8}.db-mask.is-on{background:#FFF0F9;border-color:#283730;box-shadow:0 0 0 1px #283730}.db-mask__in{position:absolute;opacity:0;pointer-events:none}.db-mask__box{position:relative;flex:0 0 auto;width:2rem;height:2rem;border:1.5px solid #cfc5bd;border-radius:.5rem;background:#fff}.db-mask.is-on .db-mask__box{background:#283730;border-color:#283730}.db-mask.is-on .db-mask__box::after{content:"";position:absolute;left:.62rem;top:.2rem;width:.45rem;height:.9rem;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg)}.db-mask__in:focus-visible+.db-mask__box{outline:2px solid #283730;outline-offset:2px}.db-mask__img{flex:0 0 auto;width:5.2rem;height:5.2rem;object-fit:cover;border-radius:.8rem;background:#f6efe9}.db-mask__txt{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:.2rem;line-height:1.3}.db-mask__txt b{font-size:1.35rem}.db-mask__txt small{color:#5b6159;font-size:1.1rem}.db-mask__price{flex:0 0 auto;text-align:right;font-size:1.35rem;font-weight:800;white-space:nowrap}.db-mask__price s{margin-right:.3rem;color:#8a8f87;font-weight:500}@media (max-width:749px){.db-mask{gap:.8rem;padding:.9rem}.db-mask__img{width:4.4rem;height:4.4rem}.db-mask__txt b{font-size:1.2rem}.db-mask__txt small{font-size:1rem}.db-mask__price{font-size:1.2rem}}';
          document.head.appendChild(st);
        }
        var img = p.featured_image ? '<img class="db-mask__img" src="' + esc(sized(p.featured_image, 160)) + '" alt="" width="52" height="52" loading="lazy">' : '';
        var price = sale < full ? '<s>' + money(full) + '</s>' + money(sale) : money(full);
        var lab = document.createElement('label');
        lab.className = 'db-mask';
        lab.setAttribute('data-db-mask-card', '');
        lab.innerHTML = '<input type="checkbox" class="db-mask__in" data-db-mask data-vid="' + esc(vr.id) + '"><span class="db-mask__box" aria-hidden="true"></span>' + img + '<span class="db-mask__txt"><b>Add the Biodance Bio-Collagen sheet mask</b><small>Our weekly boost: use it once or twice a week with your routine.</small></span><span class="db-mask__price">' + price + '</span>';
        var cb = lab.querySelector('input');
        cb.addEventListener('change', function(){ lab.classList.toggle('is-on', cb.checked); });
        actions.parentNode.insertBefore(lab, actions);
      })
      .catch(function(){});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountMask); else mountMask();

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form], form.quick-add-form')) return;
    if (e.defaultPrevented) return;
    if (isCart(window.location.pathname)) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('button[type=submit]');
    var label = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
    var original = label ? label.textContent : (btn ? btn.textContent : '');
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding...'; else btn.textContent = 'Adding...'; }
    function restore(){ if (btn) { btn.disabled = false; if (label) label.textContent = original; else btn.textContent = original; } }
    var added = false;
    var maskCb = form.querySelector('[data-db-mask]');
    var pre = Promise.resolve();
    if (maskCb && maskCb.checked && maskCb.getAttribute('data-vid')) {
      var qEl = form.querySelector('[data-quantity-input]');
      var qn = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      pre = fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(maskCb.getAttribute('data-vid')), quantity: qn }) }).catch(function(){});
    }
    pre.then(function(){ return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }); })
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
      .then(function(res){
        if (!res.ok) { restore(); window.alert((res.j && (res.j.description || res.j.message)) || 'We could not add that. Please try again.'); return null; }
        added = true;
        return getCart().then(function(cart){
          restore();
          openDrawer(cart);
          setTimeout(function(){ if (open) getCart().then(function(c2){ if (open && (c2.item_count !== cart.item_count || c2.items.length !== cart.items.length)) render(c2); }); }, 1400);
        });
      })
      .catch(function(){ restore(); if (!added) form.submit(); });
  }, true);

  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a || (el && el.contains(a))) return;
    if (a.host && a.host !== window.location.host) return;
    if (!isCart(a.getAttribute('href') || '')) return;
    if (isCart(window.location.pathname)) return;
    e.preventDefault();
    getCart().then(openDrawer);
  }, true);

  function mountPage(){
    if (!isCart(window.location.pathname) || !ssOn()) return;
    var anchor = document.querySelector('.db-stack') || document.getElementById('CartForm');
    if (!anchor || !anchor.parentNode) return;
    getCart().then(function(cart){
      if (!cart.items.length) return;
      var box = document.createElement('section');
      box.className = 'v4c-page';
      box.innerHTML = progressHtml(cart);
      anchor.parentNode.insertBefore(box, anchor);
    });
  }
  if (document.readyState !== 'loading') mountPage(); else document.addEventListener('DOMContentLoaded', mountPage);

  window.DanellaV4 = window.DanellaV4 || {};
  window.DanellaV4.openCart = function(){ getCart().then(openDrawer); };
})();